import "./loader.component.css";
const LoaderComponent = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoaderComponent;
